// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconReturnPath = 'M6.337 14.255a.918.918 0 0 1-.548-.453L3.13 8.907a1.077 1.077 0 0 1 .177-1.265L7.8 3.249a.842.842 0 0 1 .593-.25h.835L6.642 7.28a3.112 3.112 0 0 0-.359 2.296l1.17 4.997-1.116-.317Zm2.017-5.941L12.774 1h-4.38c-.746 0-1.453.29-1.993.819L1.908 6.212a3.072 3.072 0 0 0-.535 3.65l2.66 4.895a2.938 2.938 0 0 0 1.756 1.422l4.384 1.249L8.23 9.12a1.092 1.092 0 0 1 .124-.806Zm3.34 1.397H11v2h.692c.721 0 1.308.586 1.308 1.307 0 .464-.239.884-.639 1.123l1.024 1.718a3.322 3.322 0 0 0 1.615-2.841 3.31 3.31 0 0 0-3.308-3.307ZM11 6h1c3.86 0 7 3.141 7 7a7.041 7.041 0 0 1-3.417 6.015l-1.025-1.717A4.967 4.967 0 0 0 17.001 13c0-2.757-2.243-5-5-5h-1V6Z';
var IconReturn = baseIcon('IconReturn', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconReturnPath
});
export default IconReturn;
//# sourceMappingURL=index.js.map